import React, { Component } from 'react';
import {Route} from "react-router-dom";
import Home from "../../pages/home/Home";
import Items from "../../pages/items/Items";
import {withRouter} from 'react-router-dom';
import Authenticate from "../../pages/authenticate/Authenticate";
import Guides from "../../pages/guides/Guides";
import Guide from "../../pages/guide/Guide";
import Skins from "../../pages/skins/Skins";

class Router extends Component {

    getRoutes = () => {
        return (
            <div>
                <Route exact path="/" component={Home}/>
                <Route path="/items" component={Items}/>
                <Route path="/guides" component={Guides}/>
                <Route path="/guide/:guideId" component={Guide}/>
                <Route path="/skins" component={Skins}/>
                <Route path="/authenticate" component={Authenticate}/>
            </div>
        )
    };

    render(){
        return (
            <div>
                {this.getRoutes()}
            </div>
        )
    }
}

export default withRouter(Router);


// WEBPACK FOOTER //
// ./src/core/Router/Router.js